<template>
    <div class="app-main customs">
        <div class="top-bar">
            <el-input  v-model="batch"  @keyup.enter.native="start" class="m-width-3 m-right-3" placeholder="批次" ></el-input> 
            <el-select v-model="mode"  class="m-width-3 m-right-3">
                <el-option  label="海运" :value="1"></el-option>
                <el-option  label="空运" :value="2"></el-option>
                <el-option  label="人运" :value="3"></el-option>
            </el-select> 
            <el-input ref="input" v-model="barcode"  @keyup.enter.native="start" class="m-width-3 m-right-3" placeholder="商品条形码" ></el-input>    
            <el-input ref="input" v-if="id == 6|| id == 28" v-model="number"  @keyup.enter.native="start" class="m-width-3 m-right-3" placeholder="数量" ></el-input>    
                 
            <el-button @click="handleConfirm" type="success" plain class="m-right-3">盘点确认</el-button>
            <!-- <a href="https://myadmin.moobyyoho.com/customsexcelexport" v-show="tableData.length != 0">
                <el-button type="primary" plain>表格导出</el-button>
            </a> -->
        </div>

        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table  :data="tableData" empty-text="暂无盘点数据" height="600" style="width: 100%">
                <el-table-column prop="purchase_pic_url" label="商品图片"   align="center"  >
                    <template slot-scope="scope">
                        <table-img :src="scope.row.purchase_pic_url"></table-img>
                    </template>
                </el-table-column>
                <el-table-column prop="barcode"            label="条形码"     align="center" min-width="140"> </el-table-column>
                <el-table-column prop="purchase_title"     label="商品名称"   align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="attr_symbol_string" label="规格属性"   align="center"  >
                    <template slot-scope="scope" v-if="scope.row.attr_symbol_string">    
                        <el-tag size="medium" class="m-right-3">{{scope.row.attr_symbol_string}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="batch"              label="批次"      align="center"></el-table-column>
                <el-table-column prop="to_number"          label="盘点数量"  align="center"></el-table-column>
                <el-table-column prop="mode_data"          label="运输方式"  align="center"></el-table-column>
                <el-table-column prop="created_at"         label="入库时间"  align="center"  min-width="160"></el-table-column>
                <el-table-column prop="checknum"           label="编辑"      align="center">
                    <template slot-scope="scope">
                        <p><el-button type="danger" plain size="mini" @click="handleDel(scope.row.id)">数量减一</el-button></p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        


    </div>
</template>

<script>
import { canada_get, canada, canada_del, canada_ok } from '@/api/warehouse.js'
import { userinfo } from '@/api/home.js'
import tableImg from '@/components/Image.vue'
export default {
    components:{ tableImg },
    data() {
        return {
            batch:'',
            barcode:'',
            mode:1,
            tableData:[],     
            number: '',
            id:''     
        }
    },
    methods: {
        getData(){
            canada_get(0).then(res => {
                if(res){
                    this.tableData = res.data
                }else{
                    this.tableData = []
                }
            })
        },
        start(){
            
            if(this.batch === ""){
                this.$message.error("请完善商品批次...")
                return false
            }
            if(this.barcode === ""){
                this.$message.error("请完善商品条形码...")
                return false
            }
            let params = {
                batch:this.batch,
                mode:this.mode,
                barcode:this.barcode,
                number:this.number,
            }
            canada(params).then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.barcode = ""
                    this.number = ""
                    this.$refs.input.focus()
                    this.getData()
                }
            })
        },
        // 盘点确认
        handleConfirm(){
            canada_ok().then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.barcode = ""
                    this.number = ""
                    this.$refs.input.focus()
                    this.getData()
                }
            })
            
        },
        handleDel(id){
            canada_del(id).then(res => {
                if(res){
                    this.$message({type:'success', message:res.msg, duration:1500})
                    this.getData()
                }
            })
        },
        getInfo() {
            userinfo().then(res => {
                if(res) {
                    this.id = res.data.id   
                }
            })
        }
    },
    created(){
        this.getInfo()
        this.getData()
    },
    activated() {
        this.getInfo()
        this.getData()
    },
}
</script>

